export default (function (v) {
  return v;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/identity.js
// module id = 110
// module chunks = 0